/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');
var GetEntityIdentifiers = require('../../common/services/GetEntityIdentifiers');

var GetEntitySiteRecordKeeping = require('../../entity-dashboard/services/GetEntitySiteRecordKeeping');

var EntityRecordsLocationChangeFormView = require('../views/EntityRecordsLocationChangeFormView');

module.exports = function(entityId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetEntitySiteRecordKeeping(entityId), GetEntityIdentifiers(entityId))
    .done(function(booksAndRecords, entityIdentifiers) {
      NavUtils.navigate('ext/nondep/entity/' + entityId + '/records-location-change');
      _.each(booksAndRecords.siteRecordKeepings, function(record) {
        var recordAddress = record.address;
        delete recordAddress.id;
        record = _.extend(record, recordAddress);
      });
      Scaffold.content.show(
        new EntityRecordsLocationChangeFormView({
          model: new Backbone.Model({
            entityId: entityId,
            booksAndRecords: booksAndRecords.siteRecordKeepings,
            entityIdentifiers: entityIdentifiers,
            instructionsDocument: booksAndRecords.instructionsDocument
          })
        })
      );
      NProgress.done();
    })
    .fail(function(err) {
      NProgress.done();
    });
};
